import { render, staticRenderFns } from "./received.vue?vue&type=template&id=48b3ef5a&"
import script from "./received.vue?vue&type=script&lang=js&"
export * from "./received.vue?vue&type=script&lang=js&"
import style0 from "./received.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports